import { Modal } from "../../../../components/Modal";
import React from "react";
import IntlMessages from "../../../../components/utility/intlMessages";
import alertIcon from "../../../../assets/images/alert.svg";
import { useIntl } from "react-intl";

export default function RemoveUserModal({ open, onCancel, onSubmit }) {
  const intl = useIntl()
  return (
    <Modal.Root visible={open}>
      <Modal.Header onCancelAction={onCancel} title={intl.formatMessage({ id: "page.invite.delete.user.modal.title" })} />
      <Modal.Icon>
        <img alt="Alert" src={alertIcon} />
      </Modal.Icon>
      <Modal.Content>
        <p className="text-sm text-gray-500">
          <IntlMessages id="page.invite.delete.user.modal.description" />
        </p>
      </Modal.Content>
      <Modal.Actions
        submitText={<IntlMessages id="confirm" />}
        onSubmitAction={onSubmit}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
